// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {CostCenter, deleteCostCenter} from './api'
import {KTIcon} from '../../../_metronic/helpers'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-hot-toast'
import {useState} from 'react'
import {useLayout} from '../../../_metronic/layout/core'

// ─── Helper ───────────────────────────────────────────────────────────────────

const formatSlug = (slug: string): string => {
  if (!slug) return ''
  return slug
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

// ─── Columns ──────────────────────────────────────────────────────────────────

const getCostCenterColumns = (): ReadonlyArray<Column<CostCenter>> => [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Code' className='min-w-100px ps-4 text-center' />
    ),
    id: 'center_code',
    accessor: 'center_code',
    sortType: 'alphanumeric',
    Cell: ({...props}) => (
      <span className='badge badge-light-dark fw-bold'>
        {props.data[props.row.index].center_code}
      </span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Name' className='min-w-150px text-center' />
    ),
    accessor: 'center_name',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Department' className='min-w-125px text-center' />
    ),
    accessor: 'department',
    sortType: 'string',
    Cell: ({...props}) => <div>{formatSlug(props.data[props.row.index].department)}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Manager' className='min-w-125px text-center' />
    ),
    accessor: 'department_head',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Budget' className='min-w-125px text-center' />
    ),
    accessor: 'total_budget',
    sortType: 'basic',
    Cell: ({...props}) => (
      <div>
        &#8377;{' '}
        {props.data[props.row.index].total_budget?.toLocaleString('en-IN', {
          minimumFractionDigits: 2,
        })}
      </div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-100px text-center' />
    ),
    accessor: 'status',
    sortType: 'string',
    Cell: ({...props}) => {
      const status = props.data[props.row.index].status?.toLowerCase()
      return (
        <span
          className={`badge fw-bold ${
            status === 'active' ? 'badge-light-success' : 'badge-light-danger'
          }`}
        >
          {status?.toUpperCase()}
        </span>
      )
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='min-w-100px text-center' />
    ),
    accessor: 'actions',
    sortable: false,
    Cell: ({...props}) => {
      const {company} = useLayout()
      const [showDeleteModal, setShowDeleteModal] = useState(false)

      const handleDelete = async () => {
        deleteCostCenter(company.value, props.data[props.row.index].cost_center_id)
          .then((res) => res?.detail && toast.success(res.detail))
          .catch((err) => err && toast.error(err))
          .finally(() => setShowDeleteModal(false))
      }

      return (
        <>
          <div className='d-flex justify-content-center flex-shrink-0'>
            <div
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Delete'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => setShowDeleteModal(true)}
            >
              <KTIcon iconName='trash' className='fs-3' />
            </div>
          </div>

          <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
            id='delete_cost_center'
            role='dialog'
            data-backdrop='false'
            aria-hidden='true'
            tabIndex='-1'
            show={showDeleteModal}
            animation={false}
          >
            <div className='modal-content'>
              {/*begin::Header*/}
              <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                <h5 className='fw-bold m-0'>Delete Cost Center</h5>
                <div className='d-flex ms-2'>
                  {/*begin::Close*/}
                  <div
                    className='btn btn-icon btn-sm btn-light-primary ms-2'
                    data-bs-dismiss='modal'
                    onClick={() => setShowDeleteModal(false)}
                  >
                    <KTIcon className='fs-1' iconName='cross' />
                  </div>
                  {/*end::Close*/}
                </div>
              </div>
              {/*end::Header*/}
              <div className='text-center py-5 px-5'>
                Are you sure you want to delete this Cost Center? This action cannot be undone.
              </div>
              <div className='text-center pt-5 pb-5'>
                <button
                  type='reset'
                  onClick={() => setShowDeleteModal(false)}
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  onClick={handleDelete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>
        </>
      )
    },
  },
]

export {getCostCenterColumns}
